export function isvalidCNPJ(_cnpj) {
    _cnpj =
        _cnpj && _cnpj.length > 11 && _cnpj.length < 14
        ? _cnpj.toString().padStart(14, '0')
        : _cnpj;
    return validarCNPJAlfaNumerico(_cnpj);
}


function validarCNPJAlfaNumerico(cnpj) {
    try {
        const TAMANHO_CNPJ = 14;
        const TAMANHO_CNPJ_SEM_DV = 12;
        const REGEX_CNPJ_SEM_DV = /^([A-Z\d]){12}$/;
        const REGEX_CNPJ = /^([A-Z\d]){12}(\d){2}$/;
        const REGEX_CARACTERES_MASCARA = /[./-]/g;
        const REGEX_CARACTERES_NAO_PERMITIDOS = /[^A-Z\d./-]/i;
        const VALOR_BASE = '0'.charCodeAt(0);
        const PESOS_DV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        const CNPJ_ZERADO = '00000000000000';

        const removeMascaraCNPJ = (cnpj) => {
            return cnpj.replace(REGEX_CARACTERES_MASCARA, '');
        };

        const calculaDV = (cnpj) => {
            if (!REGEX_CARACTERES_NAO_PERMITIDOS.test(cnpj)) {
                const cnpjSemMascara = removeMascaraCNPJ(cnpj);

                if (
                    REGEX_CNPJ_SEM_DV.test(cnpjSemMascara) &&
                    cnpjSemMascara !== CNPJ_ZERADO.substring(0, TAMANHO_CNPJ_SEM_DV)
                ) {
                    let somatorioDV1 = 0;
                    let somatorioDV2 = 0;

                    for (let i = 0; i < TAMANHO_CNPJ_SEM_DV; i++) {
                        const asciiDigito = cnpjSemMascara.charCodeAt(i) - VALOR_BASE;
                        somatorioDV1 += asciiDigito * PESOS_DV[i + 1];
                        somatorioDV2 += asciiDigito * PESOS_DV[i];
                    }

                    const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11);
                    somatorioDV2 += dv1 * PESOS_DV[TAMANHO_CNPJ_SEM_DV];
                    const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11);

                    return `${dv1}${dv2}`;
                }
            }
            throw new Error(
                'Não é possível calcular o DV pois o CNPJ fornecido é inválido',
            );
        };

        if (!REGEX_CARACTERES_NAO_PERMITIDOS.test(cnpj)) {
            const cnpjSemMascara = removeMascaraCNPJ(cnpj)
                .toUpperCase()
                .padStart(TAMANHO_CNPJ, '0');

            if (REGEX_CNPJ.test(cnpjSemMascara) && cnpjSemMascara !== CNPJ_ZERADO) {
                const dvInformado = cnpjSemMascara.substring(TAMANHO_CNPJ_SEM_DV);
                const dvCalculado = calculaDV(
                cnpjSemMascara.substring(0, TAMANHO_CNPJ_SEM_DV),
                );
                return dvInformado === dvCalculado;
            }
        }
    } catch (error) {
        return false;
    }
    return false;
}

